import { useQuery } from 'react-query';

import { ActivitySectorsService } from 'src/Services/API';

import { QueryKeys } from '../types';

export const useFetchActivitySectors = () => {
  return useQuery(
    [QueryKeys.fetchActivitySectors],
    async () => {
      return ActivitySectorsService.activitySectorsControllerGetActivitySectors();
    },
    { staleTime: 10 * 60 * 1000, cacheTime: 10 * 60 * 1000 }
  );
};
